// extracted by mini-css-extract-plugin
export var auto = "_33-1";
export var spinner = "_33-0";